var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GeneralScaffold',[_c('PagedDataTable',{attrs:{"i18nGroup":"user","form-route":"userForm","headers":_vm.headers,"repository":_vm.userRepository,"enable-search":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }